import React from "react";
import PropTypes from "prop-types";

function getRandomColor() {
  let colors = ["#0099ce", "#ff664e", "#f5967b", "#42b77a"];
  return colors[Math.round(Math.random() * (colors.length - 1))];
}

function UserAvatar(props) {
  return (
    <div style={styles.circle}>
      <p style={styles.initials} data-testid="initials">
        {props.firstName?.charAt(0)}
        {props.lastName?.charAt(0)}
      </p>
    </div>
  );
}

UserAvatar.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string
};

const styles = {
  circle: {
    width: "100px",
    height: "100px",
    borderRadius: "100px",
    backgroundColor: getRandomColor()
  },
  initials: {
    color: "#434343",
    fontFamily: "Open Sans",
    fontWeight: "400",
    textAlign: "center",
    fontSize: "41px",
    paddingTop: "37px"
  }
};

export default UserAvatar;
